module.exports = __webpack_public_path__ + "static/img/暂无图片.2c03e46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/暂无图片.png
// module id = 6wY3
// module chunks = 0